export const MESSAGE_TYPE = {
  ACTION_TYPE: {
    // extension -> webview
    CHECK_INIT: 'check init',
    OPEN_FILE: 'open file',
    SAVE_FILE_COMPLETE: 'save file complete',
    SAVE_AS_FILE_COMPLETE: 'saveAs file complete',
    REQUEST_FILENAME: 'request filename',
    EXPORT_PDF_COMPLETE: 'export pdf complete',

    // webview -> extension
    INIT_COMPLETE: 'init complete',
    OPEN_FILE_COMPLETE: 'open file complete',
    SAVE_FILE: 'save file',
    SAVE_AS_FILE: 'saveAs file',
    EXPORT_PDF: 'export PDF',
    OPEN_LOCAL_FILE: 'open local file',
    GET_LOCAL_FILE: 'get local file',
    RESPONSE_FILENAME: 'response filename'
  }
};
